import InnerButton from './Button';
import ButtonGroup, { ButtonGroupContext } from './Group';
import './style/index.less';
var Button = InnerButton;
Button.Group = ButtonGroup; // eslint-disable-next-line no-underscore-dangle

Button.__CYBER_BUTTON = true;
export { ButtonGroupContext };
export default Button;